import { type AppState } from "@client/types";
import { type AnyAction, type Dispatch } from "redux";

export enum Actions {
  SetToggled = "SIDE_PANEL_SET_TOGGLED"
}

export interface SetToggledActionData {
  isToggled: boolean;
}
export const toggleSidePanel = () => (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
  dispatch({
    type: Actions.SetToggled,
    data: <SetToggledActionData>{
      isToggled: !getState().widgets.sidePanel.isToggled
    }
  });
};
